import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import FilterSection from './filterSection';
import { setSearchFilters, setActiveFilters } from '../redux/slices/search.slice';
import { processContentFilters, getActiveFilters, updateFilterList } from '../utils/searchFunctions';
import Accordion from './accordion';
import Checkbox from './checkbox';
import { formatNumber } from '../helpers/CommonHelpers';
import he from 'he';

export default function Filters({isFilterActive, filterClose, onFilterChange }) {
  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState({});

  const searchOptions = useSelector(state => state.search.searchOptions);
  const searchResultsObj = useSelector(state => state.search.contentResults);
  const isFilterLoading = useSelector(state => state.search.showFilterLoading);
  const allFilters = useSelector(state => state.search.searchFilters);

  const filterCheckboxList = [1, 2, 3, 4];

  useEffect(() => {
    const filters = getActiveFilters(allFilters, searchOptions);
    dispatch(setActiveFilters(filters));

    // Set the first index to expanded on page load
    if (allFilters?.subjectArea && allFilters.subjectArea.length > 0) {
      const sortedSubjectArea = [...allFilters.subjectArea].sort((a, b) => a.name.localeCompare(b.name));
      setExpanded(prevExpanded => ({
        ...prevExpanded,
        [sortedSubjectArea[0].id]: true
      }));
    }
  },[allFilters, searchOptions]);

  const handleCheckboxChange = async (category, id, checked) => {
    let updatedSearchOpts = { ...searchOptions, loadMore: false, expandingSearch: false, skip: 0, take: 8, total: 8 };

    const updateArray = (arrayName) => {
      const currentArray = updatedSearchOpts[arrayName] || [];
      if (currentArray.includes(id)) {
        updatedSearchOpts[arrayName] = currentArray.filter(item => item !== id);
      } else {
        updatedSearchOpts[arrayName] = [...currentArray, id];
      }
    };

    switch (category) {
      case 'tech':
        updateArray('licensing_Tech');
        break;
      case 'ms':
        const updateResults = updateFilterList(allFilters.product, searchOptions.products || [], id, checked);
        updatedSearchOpts['products'] = updateResults.selected;
        break;
      case 'c':
        updateArray('cloud_OnPremises_Hybrid');
        break;
      case 'ct':
        updateArray('contentType');
        break;
      case 'mt':
        updateArray('mediaType');
        break;
      case 'sa':
        const updateResults_SA = updateFilterList(allFilters.subjectArea, searchOptions.subjectArea || [], id, checked);
        updatedSearchOpts['subjectArea'] = updateResults_SA.selected;
        break;
      case 'auth':
        updateArray('authors');
        break;
      case 'ar':
        updatedSearchOpts['archived'] = checked;
        break;
      case 'dp':
        updatedSearchOpts['datePublishedPreset'] = id;
        updatedSearchOpts['datePublishedStart'] = '';
        updatedSearchOpts['datePublishedEnd'] = '';
        break;
      case 'df':
        updatedSearchOpts['datePublishedStart'] = id;
        break;
      case 'dt':        
        updatedSearchOpts['datePublishedEnd'] = id;
      default:
        break;
    }

    if (updatedSearchOpts.searchQuery === '' 
      && (updatedSearchOpts.contentType && updatedSearchOpts.contentType.length === 1 
          && (updatedSearchOpts.contentType.filter(f => f === 'podcasts').length === 1 
              || updatedSearchOpts.contentType.filter(f => f === 'post').length === 1
              || updatedSearchOpts.contentType.filter(f => f === 'webinars').length === 1
              || updatedSearchOpts.contentType.filter(f => f === 'analyst_reports').length === 1
            )
          ) 
      ) {
        updatedSearchOpts = { ...updatedSearchOpts, sortBy: 'date' };
    } else {
      updatedSearchOpts = { ...updatedSearchOpts, sortBy: 'relevance' };
    }

    
    if (updatedSearchOpts.searchQuery === '' 
        && (updatedSearchOpts.contentType && updatedSearchOpts.contentType.length === 1 
            && (updatedSearchOpts.contentType.filter(f => f === 'infographics').length === 1)
            ) 
        ) {
          updatedSearchOpts = { ...updatedSearchOpts, searchType: 2 };
    } else {
        updatedSearchOpts = { ...updatedSearchOpts, searchType: 0 };
    }

    await handleUpdates(updatedSearchOpts);
  };  

  const handleUpdates = async (updatedSearchOpts) => {
    var currentFilters = JSON.parse(JSON.stringify(allFilters));
    const filters = processContentFilters(searchResultsObj, currentFilters, updatedSearchOpts);
    dispatch(setSearchFilters(filters));
    dispatch(setActiveFilters());
    
    if (onFilterChange) onFilterChange(updatedSearchOpts);
  };

  // Toggle function to expand/collapse sections
  const toggleExpand = (id) => {
    setExpanded(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };  

  return <>
    <div className={`resultsFiltersSidebar ${isFilterActive ? 'resultsFiltersSidebarOpen' : ''}`}>
      <div className="resultsFilterCard">
        <div className="resultsFiltersHeader">
          <p className="resultsFiltersHeaderTitle">Filters</p>
          <button className="resultsFiltersClose" title="Close" onClick={filterClose}>
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.99896 4.75729L1.34479 7.41146C1.24549 7.51076 1.1191 7.56042 0.965625 7.56042C0.812153 7.56042 0.685764 7.51076 0.586458 7.41146C0.487153 7.31215 0.4375 7.18576 0.4375 7.03229C0.4375 6.87882 0.487153 6.75243 0.586458 6.65313L3.24063 3.99896L0.586458 1.34479C0.487153 1.24549 0.4375 1.1191 0.4375 0.965625C0.4375 0.812153 0.487153 0.685764 0.586458 0.586458C0.685764 0.487153 0.812153 0.4375 0.965625 0.4375C1.1191 0.4375 1.24549 0.487153 1.34479 0.586458L3.99896 3.24063L6.65313 0.586458C6.75243 0.487153 6.87882 0.4375 7.03229 0.4375C7.18576 0.4375 7.31215 0.487153 7.41146 0.586458C7.51076 0.685764 7.56042 0.812153 7.56042 0.965625C7.56042 1.1191 7.51076 1.24549 7.41146 1.34479L4.75729 3.99896L7.41146 6.65313C7.51076 6.75243 7.56042 6.87882 7.56042 7.03229C7.56042 7.18576 7.51076 7.31215 7.41146 7.41146C7.31215 7.51076 7.18576 7.56042 7.03229 7.56042C6.87882 7.56042 6.75243 7.51076 6.65313 7.41146L3.99896 4.75729Z" fill="white"></path>
              </svg>
          </button>
        </div>
        {isFilterLoading ? (
          <div className='mt-4'>
            {/* <InlineSpinner /> */}
            <div className="resultsFilterbody placeholder-glow">
              <div className="filterList">
              {filterCheckboxList.map((index) => (
                <div className="filterAccordion" key={index}>
                  <div className="accordionTitle">
                    <span className="resultsHeading placeholder col-6"></span>
                  </div>
                  <div className="filterTier openContent">
                    <ul>
                    {filterCheckboxList.map((index) => (
                      <li key={index}>
                        <span className="resultsHeading placeholder col-12"></span>
                      </li>
                    ))}
                    </ul>
                  </div>
                </div>
              ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="resultsFilterbody">
            <div className="filterList">
                {allFilters?.licensing_Tech && allFilters?.licensing_Tech.length > 0 && (
                  <FilterSection
                    itemArray={[...(allFilters.licensing_Tech ?? [])].sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )}
                    selectedArray={searchOptions?.licensing_Tech ?? []}
                    title="Licensing/Tech Content" onChange={(id, checked) => handleCheckboxChange('tech', id, checked)}
                    defaultIsOpen={true} />
                )}

                {allFilters?.subjectArea && allFilters?.subjectArea.length > 0 && (
                  <Accordion title="Subject Area" titleClass="accordionTitle" variant="bottomBorder" defaultIsOpen={true}>
                    <ul>
                      {[...allFilters.subjectArea].sort((a, b) => a.name.localeCompare(b.name)).map((item) => {
                        const isProductChecked = item.filters && item.filters.some(child => child.checked);
                        return (
                          <li key={item.id}>
                            <div className={"filterExpandWrap"} aria-expanded={expanded[item.id] || false}>
                              <Checkbox
                                id={item.id}
                                value={item.id}
                                label={he.decode(item.name)}
                                labelOnClick={() => toggleExpand(item.id)}
                                labelClass='inter'
                                checked={item.checked || isProductChecked || false}
                                onChange={(e) => {
                                  if(!item.checked && isProductChecked){
                                    handleCheckboxChange('sa', item.id, true);
                                  }else{
                                    handleCheckboxChange('sa', item.id, e.target.checked);
                                  }                              
                                }}
                                disabled={item.count == 0 ? true : false}
                                formatechild={item.count}
                              />
                              {item.filters && item.filters.length > 0 && (
                                <button className={`filterExpandTrigger ${expanded[item.id] ? "up" : "down"}`} onClick={() => toggleExpand(item.id)} title={expanded[item.id] ? "Hide" : "Expand"}>&nbsp;</button>
                              )}
                            </div>
                            {expanded[item.id] && item.filters && item.filters.length > 0 && (
                              <ol className="filterExpandChildren">
                                {[...item.filters].sort((a, b) => a.name.localeCompare(b.name)).map(itemProd => {
                                  return (
                                    <li key={itemProd.id}>
                                      <div aria-expanded={expanded[itemProd.id] || false}>
                                        <Checkbox
                                          id={itemProd.id}
                                          value={itemProd.id}
                                          label={he.decode(itemProd.name)}
                                          labelClass='inter'
                                          labelOnClick={() => toggleExpand(itemProd.id)}
                                          checked={itemProd.checked || false}
                                          onChange={(e) => {
                                            if(!itemProd.checked){
                                              handleCheckboxChange('sa', itemProd.id, true)
                                            }else{
                                              handleCheckboxChange('sa', itemProd.id, e.target.checked)
                                            }
                                          }}
                                          disabled={itemProd.count == 0 ? true : false}
                                          formatechild={itemProd.count}
                                        />
                                      </div>
                                    </li>
                                  )
                                })}
                              </ol>
                            )}
                          </li>
                        )
                      }
                    )}
                  </ul>
                </Accordion>
              )}

                {allFilters?.product && allFilters?.product.length > 0 && (
                  <Accordion title="Microsoft Product" titleClass="accordionTitle" variant="bottomBorder">
                    <ul>
                      {[...allFilters.product].sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                        const isProductChecked = item.filters && item.filters.some(child => child.checked);
                        return (
                          <li key={item.id}>
                            <div className={"filterExpandWrap"} aria-expanded={expanded[item.id] || false}>
                              <Checkbox
                                id={item.id}
                                value={item.id}
                                label={he.decode(item.name)}
                                labelOnClick={() => toggleExpand(item.id)}
                                labelClass='inter'
                                checked={item.checked || isProductChecked || false}
                                onChange={(e) => {
                                  if(!item.checked && isProductChecked){
                                    handleCheckboxChange('ms', item.id, true);
                                  }else{
                                    handleCheckboxChange('ms', item.id, e.target.checked);
                                  }                              
                                }}
                                disabled={item.count == 0 ? true : false}
                                formatechild={item.count}
                              />
                              {item.filters && item.filters.length > 0 && (
                                <button className={`filterExpandTrigger ${expanded[item.id] ? "up" : "down"}`} onClick={() => toggleExpand(item.id)} title={expanded[item.id] ? "Hide" : "Expand"}>&nbsp;</button>
                              )}
                            </div>
                            {expanded[item.id] && item.filters && item.filters.length > 0 && (
                              <ol className="filterExpandChildren">
                                {[...item.filters].sort((a, b) => a.name.localeCompare(b.name)).map(itemProd => {
                                  return (
                                    <li key={itemProd.id}>
                                      <div aria-expanded={expanded[itemProd.id] || false}>
                                        <Checkbox
                                          id={itemProd.id}
                                          value={itemProd.id}
                                          label={he.decode(itemProd.name)}
                                          labelClass='inter'
                                          labelOnClick={() => toggleExpand(itemProd.id)}
                                          checked={itemProd.checked || false}
                                          onChange={(e) => {
                                            if(!itemProd.checked){
                                              handleCheckboxChange('ms', itemProd.id, true)
                                            }else{
                                              handleCheckboxChange('ms', itemProd.id, e.target.checked)
                                            }
                                          }}
                                          disabled={itemProd.count == 0 ? true : false}
                                          formatechild={itemProd.count}
                                        />
                                      </div>
                                    </li>
                                  )
                                })}
                              </ol>
                            )}
                          </li>
                        )
                      }
                    )}
                  </ul>
                </Accordion>
              )}

                {allFilters?.cloud_OnPremises_Hybrid && allFilters?.cloud_OnPremises_Hybrid.length > 0 && (
                  <FilterSection
                    itemArray={[...(allFilters.cloud_OnPremises_Hybrid ?? [])].sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )}                    
                    selectedArray={searchOptions?.cloud_OnPremises_Hybrid ?? []}
                    title="Cloud/On-Premises/Hybrid/Edge"
                    onChange={(id, checked) => handleCheckboxChange('c', id, checked)}
                    defaultIsOpen={true} />
                )}

                {allFilters?.contentType && allFilters?.contentType.length > 0 && (
                  <FilterSection
                    itemArray={[...(allFilters.contentType ?? [])].sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )}
                    selectedArray={searchOptions?.contentType ?? []}
                    title="Content Type"
                    onChange={(id, checked) => handleCheckboxChange('ct', id, checked)} 
                    defaultIsOpen={true} />
                )}

                {/* {allFilters?.mediaType && allFilters.mediaType.length > 0 && (
                  <FilterSection
                    itemArray={[...(allFilters.mediaType ?? [])].sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )}
                    selectedArray={searchOptions?.mediaType ?? []}
                    title="Media Type"
                    onChange={(id, checked) => handleCheckboxChange('mt', id, checked)} />
                )} */}
                {allFilters?.datePublished && allFilters.datePublished.length > 0 && (
                  <Accordion title="Date Published" variant="bottomBorder">
                        <div className="search-filter-date-wrap">
                          <div className="search-filter-date-select-wrap">
                              <label htmlFor="datePreset">Quick Select</label>
                              <select
                                  id="datePreset"
                                  value={searchOptions.datePublishedPreset || ''}
                                  onChange={e => {
                                      const preset = e.target.value;
                                      handleCheckboxChange('dp', preset);
                                  }}
                                  >
                                  <option value="">Select...</option>
                                  <option value="today">Today</option>
                                  <option value="yesterday">Yesterday</option>
                                  <option value="thisWeek">This Week</option>
                                  <option value="lastWeek">Last Week</option>
                                  <option value="thisMonth">This Month</option>
                                  <option value="lastMonth">Last Month</option>
                                  <option value="ytd">Year to Date (YTD)</option>
                                  <option value="custom">Custom Range</option>
                              </select>
                          </div>
                        </div>
                        {(searchOptions.datePublishedPreset === 'custom') && (
                          <div className="search-filter-date-wrap search-filter-date-time-wrap">
                            <div className="search-filter-date-select-wrap">
                            <label htmlFor="minDateInput">From</label>
                            <input
                                type="date"
                                id="minDateInput"
                                value={searchOptions.datePublishedStart || ''}
                                onChange={e => handleCheckboxChange('df', e.target.value)}
                                max={searchOptions.datePublishedEnd || undefined}
                                />
                            </div>
                        
                            <div className="search-filter-date-select-wrap">
                            <label htmlFor="maxDateInput">To</label>
                            <input
                                type="date"
                                id="maxDateInput"
                                value={searchOptions.datePublishedEnd || ''}
                                onChange={e => handleCheckboxChange('dt', e.target.value)}
                                min={searchOptions.datePublishedStart || undefined}
                                />
                            </div>
                          </div>
                        )}
                        
                    </Accordion>
                )}
                {allFilters?.authors && allFilters.authors.length > 0 && (
                  <FilterSection
                    itemArray={[...(allFilters.authors.filter(a => a.name.trim() !== '') ?? [])].sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )}
                    selectedArray={searchOptions?.authors ?? []}
                    title="Authors & Analysts"
                    onChange={(id, checked) => handleCheckboxChange('auth', id, checked)} />
                )}
                {allFilters?.archived && allFilters.archived.length > 0 && (
                  <Accordion title="Archived" variant="bottomBorder">
                    <ul>
                      <li>
                        <Checkbox
                          id="isArchivedContent"
                          value="archived"
                          label="Include Archived Content"
                          checked={searchOptions?.archived && (searchOptions?.archived === true || searchOptions?.archived === 'true') ? true : false}
                          onChange={(e) => handleCheckboxChange('ar', 'isArchivedContent', e.target.checked)}
                          formatechild={allFilters?.archived?.find(a => a.id === 'archived-true') != null ? formatNumber(allFilters?.archived?.find(a => a.id === 'archived-true').count) : 0}
                        />
                      </li>
                    </ul>
                  </Accordion>
                )}                
            </div>
          </div>
        )}
        <div className="resultsFiltersFooter">
          <button className="resultsFiltersFooterCancelBtn" onClick={filterClose}>Cancel</button>
          <button className="resultsFiltersFooterApplyBtn" onClick={filterClose}>Apply Filters</button>
        </div>
      </div>
    </div>
  </>
}
